import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 20;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m9.96,-0.04c5.52285,0 10,4.47715 10,10c0,5.52285 -4.47715,10 -10,10c-5.52285,0 -10,-4.47715 -10,-10c0,-5.52285 4.47715,-10 10,-10zm0,2c-4.41828,0 -8,3.58172 -8,8c0,4.41828 3.58172,8 8,8c4.41828,0 8,-3.58172 8,-8c0,-4.41828 -3.58172,-8 -8,-8zm1,6l0,5l2,0l0,2l-6,0l0,-2l2,0l0,-3l-2,0l0,-2l4,0zm-1,-3c0.55228,0 1,0.44772 1,1c0,0.55228 -0.44772,1 -1,1c-0.55228,0 -1,-0.44772 -1,-1c0,-0.55228 0.44772,-1 1,-1z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);
